export enum PageId {
  Unknown = 'unknown',
  Accounts = 'accounts',
  Account = 'account',
  AccountExecutives = 'account-executives',
  AccountExecutive = 'account-executive',
  AccountManagers = 'account-managers',
  AccountManager = 'account-manager',
  Activities = 'activities',
  Activity = 'activity',
  ActivityEmployee = 'activity-employee',
  CarrierAppetite = 'carrier-appetite',
  DataManagement = 'data-management',
  Documents = 'documents',
  Document = 'document',
  DocumentsCompare = 'documents-compare',
  DocumentsCompareGroup = 'documents-compare-group',
  Home = 'home',
  Producers = 'producers',
  Producer = 'producer',
  Industries = 'industries',
  Industry = 'industry',
  LossRun = 'loss-run',
  Markets = 'markets',
  Market = 'market',
  RetailClients = 'retail-clients',
  RetailClient = 'retail-client',
  MgaProducers = 'mga-producers',
  MgaProducer = 'mga-producer',
  MonolineRatios = 'monoline-ratios',
  Products = 'products',
  Product = 'product',
  Goals = 'goals',
  Insights = 'insights',
  Opportunities = 'opportunities',
  Opportunity = 'opportunity',
  Kpi = 'kpi',
  Retention = 'retention',
  QueryReport = 'query-report',
  WhatsNew = 'whats-new',

  UserAgreement = 'user-agreement',

  // Workflows pages
  Workflows = 'workflows',
}

export enum SectionId {
  Alerts = 'alerts',
  Accounts = 'accounts',
  AverageAccountSize = 'avg-account-size',
  AverageIncurredByLagTime = 'avg-incurred-by-lag-time',
  AccountDetails = 'account-details',
  AccountManagers = 'account-managers',
  AverageProductsPerClient = 'avg-products-per-client',
  Activities = 'Activities',
  ActivitiesLeaderboard = 'activities-leaderboard',
  ActivityPerformance = 'activity-performance',
  AgencyStatuses = 'agency-statuses',
  BasicInfo = 'basic-info',
  ByProduct = 'by-product',
  BizOrgsByCarrier = 'biz-orgs-by-carrier',
  ByIndustry = 'by-industry',
  ByCarrier = 'by-carrier',
  BookProfile = 'book-profile',
  BookPerformance = 'book-performance',
  CarrierAppetite = 'carrier-appetite',
  ClientSize = 'client-size',
  CodeEditor = 'code-editor',
  ComparisonPeriods = 'comparison-periods',
  Commissions = 'commissions',
  Coverage = 'coverage',
  Endorsements = 'endorsements',
  Exclusions = 'exclusions',
  Form5500 = 'form-5500',
  FinancialInfo = 'financial-info',
  Financials = 'financials',
  FrequencySeverity = 'frequency-severity',
  Growth = 'growth',
  Goals = 'goals',
  Insights = 'insights',
  KpiCatalog = 'kpi-catalog',
  Lost = 'lost',
  Leaderboard = 'leaderboard',
  LifetimeValue = 'lifetime-value',
  Metrics = 'metrics',
  MyKpiList = 'my-kpi-list',
  MonolineRatios = 'monoline-ratios',
  Network = 'network',
  OverallKpi = 'overall-kpi',
  Overview = 'overview',
  Opportunities = 'opportunities',
  OverdueActivities = 'overdue-activities',
  Policies = 'policies',
  ProducersSupport = 'producers-support',
  PremiumFlow = 'premium-flow',
  PremiumOutflowInflow = 'premium-outflow-inflow',
  PremiumSize = 'premium-size',
  ProductionCredit = 'production-credit',
  Products = 'products',
  Retention = 'retention',
  SourceFiles = 'source-files',
  SourceUnification = 'source-unification',
  Summary = 'summary',
  Submissions = 'Submissions',
  TopIncurred = 'top-incurred',
  TopOpenClaims = 'top-open-claims',
  TotalIncurredByEffectiveYear = 'total-incurred',
  TotalIncurredByAgeRange = 'total-incurred-by-age-range',
  ClaimsByType = 'claims-by-type',
  TotalIncurredByDepartment = 'total-incurred-by-department',
  TotalIncurredByMachine = 'total-incurred-by-machine',
  TotalIncurredByOccupation = 'total-incurred-by-occupation',
  TenureAnalysis = 'tenure-analysis',
  TenureCohortAnalysis = 'tenure-cohort-analysis',
  TablePreview = 'table-preview',
  UpcomingRenewals = 'upcoming-renewals',
  VehicleSchedule = 'vehicle-schedule',
  PropertySchedule = 'property-schedule',

  // Workflows sections
  WorkflowLibrary = 'workflow-library',
  WorkflowHistory = 'workflow-history',
}
